import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import deleteImg from '../../../assets/icons/delete-files.svg';
import exclamationIcon from '../../../assets/icons/icon-exclamation-mark.svg';
import './styles.css'
import ImportIcon from '../../../assets/icons/icon-import.svg'
import Dropdown from "../Dropdown";
import { useMainContext } from "../../../contexts/MainContext";
import { useCatalogsContext } from "../../../contexts/CatalogsContext";

const ModalCreateUser = (props) => {
    let mainContext = useMainContext();
    let catalogs = useCatalogsContext();
    const { showModal, setShow, setCancelAction, handlerAccept, cancel, success, edit, dataUser, nameCatalog, hasStatus } = props
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [stringFile, setStringFile] = useState("")
    const [rol, setRol] = useState("")
    const [formData, setFormData] = useState({})
    const arrayStatus = [{ "id": 1, "status": "Activo" }, { "id": 0, "status": "Inactivo" }]
    /**
        * Cierra el modal.
    */
    const handleClose = () => {

        setShow(false);
        setFormData({})
    }

    /**
        * Comfirmacion de borrado.
    */
    useEffect(() => {
        setIsSubmitted(false)
        setFormData({})

        if (edit) {

            if (hasStatus)
                setFormData({
                    status: initCombo(0, "id", dataUser.status ? 1 : 0),
                    itemID: dataUser.itemID,
                    name: dataUser.name
                })
            else
                setFormData({
                    itemID: dataUser.itemID,
                    name: dataUser.name
                })
        } else {
            setFormData({})
        }

    }, [showModal, dataUser])
    const sendData = async () => {
        setIsSubmitted(true)

        if (valitation()) {
            await handlerAccept(formData)
            await setFormData({})
        }

    }
    const valitation = () => {
        if (hasStatus) {
            if (!formData
                || formData.name === undefined
                || formData?.name.trim() === ""
                || formData.name === null
                || formData.status === undefined
                || formData?.status === ""
                || formData.status === null)
                return false
            else
                return true
        } else {
            if (!formData
                || formData.name === undefined
                || formData?.name.trim() === ""
                || formData.name === null)
                return false
            else
                return true
        }

    }


    const onFormDataChange = async (name, e) => {
        setIsSubmitted(false)
        setFormData({ ...formData, [name]: e.value });

    }
    const initCombo = (catalog, filterBy1, filterBy2) => {
        if (arrayStatus) {

            let dato = arrayStatus.filter((element) => { return element[filterBy1] == filterBy2 })[0];
            return dato;
        }
        else
            return null;
    }

    return (
        //TODO: Fix styles
        <section>
            <Modal size={"one-input-form"} show={showModal} onHide={() => { handleClose() }} backdrop="static" centered >
                <Modal.Header className="no-border p-1" closeButton>
                    <Modal.Title className="pl-3"></Modal.Title>
                </Modal.Header>
                <Modal.Body className={"text-center"} >
                    <div className="custom-card">
                        <div className="custom-card-header px-3 d-flex">
                            <h4 className="py-3">{edit ? "EDITAR" : "AGREGAR"} {nameCatalog}</h4>
                            <div className=" py-2 d-flex justify-content-end">
                                {/*<button onClick={() => { setShowModal(true) }} className="btn btn-primary"><span className="d-inline-block pr-4">Nueva importación</span> +</button>*/}.
                            </div>
                        </div>
                        <div className="custom-card-body px-3">
                            <div className="row">
                                <div className="form-group with-message col-6">
                                    <label className="input-label form-label">
                                        * Nombre
                                    </label>
                                    <div className="">
                                        <input type="text" value={formData.name} onChange={(e) => { onFormDataChange("name", e.target) }} maxLength="300" className="form-control black-border large-input" />
                                        {
                                            (isSubmitted && !formData.name) &&
                                            <p className="error">*Campo Nombre obligatorio.</p>
                                        }
                                        {
                                            (isSubmitted && formData?.name && formData?.name.trim() == "") &&
                                            <p className="error">*No se permiten solo espacios.</p>

                                        }
                                    </div>
                                </div>
                                {hasStatus && <div className="col-6 form-group with-message">
                                    <label className="input-label form-label">
                                        * Estatus
                                    </label>
                                    <div className="">
                                        {
                                            (isSubmitted && !formData.status) &&
                                            <p className="error">*Campo Estatus obligatorio.</p>
                                        }
                                        <Dropdown value={formData.status} options={arrayStatus} onChange={(e) => { onFormDataChange("status", e) }} optionValue="id" optionLabel="status" className="w-100" />
                                    </div>
                                </div>}
                            </div>

                        </div>
                    </div>
                    <div
                        className="container d-flex justify-content-end mt-5">
                        <button className="btn btn-white " onClick={() => { handleClose() }}>Cancelar</button>

                        <button className="btn btn-primary ml-3" onClick={sendData}>{edit ? "Actualizar" : "Agregar"}</button>
                    </div>
                </Modal.Body>
            </Modal>
        </section>
    )
}
export default ModalCreateUser